// Phone number validation regex for Indian numbers
export const indianRegex = /^[6-9][0-9]{9}$/;

// Dropdown menu items
export const roleStatusMenuItems = [
  { label: 'Recruiter', value: 'Recruiter' },
  { label: 'Job Seeker', value: 'Job Seeker' },
  { label: 'Learner', value: 'Learner' },
];
